import { homeConstants } from "../constants";

export default function (
  state = {
    sortByPrice: true,
    selectedAlternateList: null,
    firebaseMessage:null
  },
  action
) {
  switch (action.type) {
    case homeConstants.SORT_BY_PRICE:
      return {
        ...state,
        sortByPrice: action.data,
      };
    case homeConstants.GET_FIREBASE_NOTIFICATION:
      return {
        ...state,
        firebaseMessage: action.data,
      };
    case homeConstants.SELECTED_ALTERNATE_LIST:
      return {
        ...state,
        selectedAlternateList: action.data,
      };
    case homeConstants.SELECTED_BRANDED_DETAILS:
      return {
        ...state,
        selectedBrandedInfo: action.data,
      };
    case homeConstants.SELECTED_GENERIC_DETAILS:
      return {
        ...state,
        selectedGenericInfo: action.data,
      };
    default:
      return state;
  }
}
